import React from "react";
import PropTypes from "prop-types";
import generateID from "../../../utils/string-utils";
var ConsentRadioButton = function (props) {
    var id = props.id, radioName = props.radioName, acceptRadioLabel = props.acceptRadioLabel, refuseRadioLabel = props.refuseRadioLabel, acceptAll = props.acceptAll, refuseAll = props.refuseAll, onAcceptCallback = props.onAcceptCallback, onRefuseCallback = props.onRefuseCallback;
    var _id = id || generateID();
    var acceptAllChecked = function (e) {
        onAcceptCallback === null || onAcceptCallback === void 0 ? void 0 : onAcceptCallback(e.target.checked);
    };
    var refuseAllChecked = function (e) {
        onRefuseCallback === null || onRefuseCallback === void 0 ? void 0 : onRefuseCallback(e.target.checked);
    };
    return (React.createElement("div", { className: "fr-consent-service__radios" },
        React.createElement("div", { className: "fr-radio-group" },
            React.createElement("input", { type: "radio", id: "accept-".concat(radioName, "-").concat(_id), name: "".concat(radioName, "-").concat(_id), value: acceptRadioLabel, onChange: function (e) { return acceptAllChecked(e); }, checked: acceptAll }),
            React.createElement("label", { className: "fr-label", htmlFor: "accept-".concat(radioName, "-").concat(_id) }, acceptRadioLabel)),
        React.createElement("div", { className: "fr-radio-group" },
            React.createElement("input", { type: "radio", id: "refuse-".concat(radioName, "-").concat(_id), name: "".concat(radioName, "-").concat(_id), value: refuseRadioLabel, onChange: function (e) { return refuseAllChecked(e); }, checked: refuseAll }),
            React.createElement("label", { className: "fr-label", htmlFor: "refuse-".concat(radioName, "-").concat(_id) }, refuseRadioLabel))));
};
ConsentRadioButton.defaultProps = { __TYPE: "ConsentRadioButton" };
ConsentRadioButton.propTypes = { __TYPE: PropTypes.any };
export default ConsentRadioButton;
